import React, {useContext, useEffect, useState} from "react";
import {ChannelContext} from "../../../Contexts/ChannelContext";
import {useProductData} from "../ProductData";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useAddProductToCart} from "../../Cart/AddProduct/api";
import {CartContext} from "../../../Contexts/CartContext";
import {UserContext} from "../../../Contexts/UserContext";
import {ProductsListContext} from "../../../Contexts/ProductsListContext";
import {SimpleModal, useSimpleModalState} from "../../../Components/SimpleModal";
import {QuantityFields} from "../../Cart/AddProduct/components/QuantityFields";
import {MinimumOrderQuantity} from "../MinimumOrderQuantity/MinimumOrderQuantity";
import {IconsDesignation} from "../IconsDesignation";
import {QuantityDisposition} from "../Components/QuantityDisposition";
import {Gallery} from "../../../Components/Gallery";
import Barcode from "react-barcode";

function NormalList(){
    const {products, setProducts} = useContext(ProductsListContext);
    const [data, setData] = useState(products);
    const [gallery, setGallery] = useState(null);

    useEffect(() => {
        setData(products);
    }, [products]);

    return(
        <div className="normal">
            <Gallery images={gallery} close={setGallery} />
            {products.map((product, key) => {
                return <Item data={product} key={product.id} setGallery={setGallery} />
            })}
        </div>
    );
}

function Item({data, setGallery}){

    const {user}                    = useContext(UserContext);
    const {setCart}                 = useContext(CartContext);
    const {products, setProducts}   = useContext(ProductsListContext);
    const channelContext            = useContext(ChannelContext);
    const product                   = useProductData(data);
    const {t}                       = useTranslation();
    const {addProductToCart} = useAddProductToCart();

    const iconsDesignation          = new IconsDesignation(product, t);

    function displayPrice() {
        if (!user && channelContext?.displayPriceNotLogged === true){
            return <div className={'price-cart'} ><span>{t('products-list.disable-price-not-logged')}</span></div>
        }

        if (user && channelContext?.displayPriceLogged === true){
            return <div className={'price-cart'}><span>{t('products-list.disable-price-logged')}</span></div>
        }

        return (
            <div className="price-cart" >
                <div className="prices" >
                    <div className="price-title" ></div>
                    <div className="price-wrapper" >
                        {product.priceNetto > 0 ?
                            <>
                                <div className="old-price" >{product.priceBefore.toFixed(2)} {t('products-list.before-tax')}</div>
                                <div className="netto" >{product.priceNetto.toFixed(2)} {t('products-list.before-tax')}</div>
                                <div className="brutto" >{product.priceBrutto.toFixed(2)} {t('products-list.after-tax')}</div>
                            </>
                            :
                            <>
                                <div className="netto" >{product.priceBefore.toFixed(2)} {t('products-list.before-tax')}</div>
                                <div className="brutto" >{product.priceBeforeBrutto.toFixed(2)} {t('products-list.after-tax')}</div>
                            </>
                        }

                        {product.isNoDiscount ? <div className={'final-price'} >{t('products-list.final-price')}</div> : ''}
                    </div>
                </div>


                <div className="add-to-cart" >
                    <QuantityFields data={{product, products, setProducts, addProductToCart}} label={true} />
                </div>
            </div>
        );
    }

    function displayQuantity() {
        if (!user && channelContext?.displayQuantityNotLogged === true){
            return <div><span>{t('products-list.disable-quantity-not-logged')}</span></div>
        }

        if (user && channelContext?.displayQuantityLogged === true){
            return <div><span>{t('products-list.disable-quantity-logged')}</span></div>
        }

        return (
            <div className="quantity" >
                <span>{t('products-list.avail')}:</span>
                <span><QuantityDisposition quantity={product.quantity} unit={product.unit} /></span>
            </div>
        );
    }

    return (
        <section className="product" >
            {iconsDesignation.getIcons()}

            <div className="thumb" style={{backgroundImage: 'url('+product.thumb+')'}} onClick={() => setGallery(product.images)} >
                <i className="fas fa-search-plus more" />
            </div>

            <div className="desc" >
                <Link to={'/product/'+product.slug} >
                    <h2>{product.name}</h2>
                </Link>
                <div className="attributes" >
                    <div className="index" >
                        <span>{t('products-list.index-et')}:</span>
                        <span>{product.indexHurt}</span>
                    </div>
                    <div className="ean" >
                        <span>{t('products-list.ean')}:</span>
                        <span>{product.ean !== null ? product.ean : '-'}</span>
                    </div>
                    {displayQuantity()}
                    <div className="package" >
                        <span>{t('products-list.in-package')}:</span>
                        <span>{product.quantityPackage}</span>
                    </div>
                    <MinimumOrderQuantity product={product} />
                </div>
            </div>
            <div className="product-actions" >
                {product.ean ?
                    <div className="barcode" >
                        <Barcode value={product.ean} displayValue={true} height={50} width={2} />
                    </div>
                    : null}
                {displayPrice()}
            </div>
        </section>
    );
}

export default NormalList;
